var React = require('react');

function IconCommit (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"currentColor","fillRule":"nonzero"},[React.createElement("path",{"d":"M6 5a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm0 1a3 3 0 1 1 0-6 3 3 0 0 1 0 6z","key":0}),React.createElement("path",{"d":"M.876 3.562c-.207 0-.376-.224-.376-.5s.169-.5.376-.5H3.5v1H.876zm7.514 0v-1h2.632c.203 0 .368.224.368.5s-.165.5-.368.5H8.39z","key":1})]));
}

IconCommit.defaultProps = {"viewBox":"0 0 12 6"};

module.exports = IconCommit;

IconCommit.default = IconCommit;
